import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { appUserLevels, gEnums } from 'global/enums/globalEnums'
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares '
import _ from 'lodash'
import React, { useContext } from 'react'

const _normalDashboardTypes = {
  total: 'total',
  fcm: 'fcm',
  admins: 'admins'
}

const _authDashboardTypes = {
  recent: 'recent',
  found: 'found',
  notFound: 'notFound',
}

const _calDashboardTypes = {
  appUsage: 'appUsage',
}

const _missingDashboardTypes = {
  missingEvent: 'missingEvent',
  missingProfile: 'missingProfile',
  nonProfiled: 'nonProfiled',
}

const _imageDashboardTypes = {
  photo: 'photo',
  nonPhoto: 'nonPhoto',
}

const _imageFileTypes = {
  photoSourced: 'photoSourced',
  getFiles: 'getFiles',
}

const _optionDashboardTypes = {
  checkAuthorizations: 'checkAuthorizations',
  getClientProfiles: 'getClientProfiles',
  authOn: 'authOn',
}

export const _appUserDashboardTypes = {
  ..._normalDashboardTypes,
  ..._authDashboardTypes,
  ..._calDashboardTypes,
  ..._missingDashboardTypes,
  ..._imageDashboardTypes,
  ..._imageFileTypes,
  ..._optionDashboardTypes,
}


export const SquaresAppUsers = ({
  adminProfiles,
  attendeeCounts,
  authOn,
  currentDataItems,
  fcmCount,
  handle_onFileDrop,
  hc_appUsers,
  hc_options,
  itemCount,
  nonProfiledAttendees,
  selectedListType,
}) => {

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appUsersAuth_state } = states ?? {}
  const { appUserAuthList, appUserAuthTotals } = appUsersAuth_state ?? {}

  const squareText = (key) => {
    switch (key) {
      case _appUserDashboardTypes.admins:
        return { text: 'Admins', count: _.size(adminProfiles) || 0 }
      case _appUserDashboardTypes.appUsage:
        return `App Usage`;
      case _appUserDashboardTypes.total:
        return { text: 'Total', count: itemCount }
      case _appUserDashboardTypes.recent:
        return { text: 'Recent', count: _.size(appUserAuthList?.[gEnums.authListTypes.recent]) || 0 }
      case _appUserDashboardTypes.found:
        return { text: 'Found', count: _.size(appUserAuthList?.[gEnums.authListTypes.found]) || 0 }
      case _appUserDashboardTypes.notFound:
        return { text: 'Not Found', count: _.size(appUserAuthList?.[gEnums.authListTypes.notFound]) || 0 }
      case _appUserDashboardTypes.missingEvent:
        return { text: 'Missing Event', count: attendeeCounts?.missingEvent || 0 }
      case _appUserDashboardTypes.missingProfile:
        return { text: 'Missing Profile', count: attendeeCounts?.missingProfile || 0 || 0 }
      case _appUserDashboardTypes.nonProfiled:
        return { text: 'Non Profiled', count: _.size(nonProfiledAttendees) || 0 }
      case _appUserDashboardTypes.photo:
        const o = _.filter(currentDataItems, item => item.appUserImage)
        return { text: 'Photo', count: _.size(o) || 0 }
      case _appUserDashboardTypes.nonPhoto:
        const y = _.filter(currentDataItems, item => !item.appUserImage)
        return { text: 'Non Photo', count: _.size(y) || 0 }
      case _appUserDashboardTypes.photoSourced:
        const z = _.filter(currentDataItems, item => item._file)
        return { text: 'Photo Sourced', count: _.size(z) || 0 }
      case _appUserDashboardTypes.fcm:
        const f = _.filter(currentDataItems, item => item.fcmTokens)
        return { text: 'Photo FCM Tokens', count: _.size(f) || 0 }
      case _appUserDashboardTypes.checkAuthorizations:
      case _appUserDashboardTypes.getClientProfiles:
      case _appUserDashboardTypes.authOn:
      case _appUserDashboardTypes.getFiles:
        return _.startCase(key)
    }
  }

  const squareIcon = (key) => {
    switch (key) {
      case _appUserDashboardTypes.admins:
        return { icon: 'user secret', iconColor: 'blue' }
      case _appUserDashboardTypes.appUsage:
        return { icon: 'calendar', iconColor: 'blue' }
      case _appUserDashboardTypes.total:
        return { icon: 'users', iconColor: 'green' }
      case _appUserDashboardTypes.recent:
        return { icon: 'users', iconColor: 'green' }
      case _appUserDashboardTypes.found:
        return { icon: 'users', iconColor: 'blue' }
      case _appUserDashboardTypes.notFound:
        return { icon: 'users', iconColor: 'red' }
      case _appUserDashboardTypes.missingEvent:
        return { icon: 'calendar outline', iconColor: 'red' }
      case _appUserDashboardTypes.missingProfile:
        return { icon: 'user outline', iconColor: 'red' }
      case _appUserDashboardTypes.fcm:
        return { icon: 'fire', iconColor: 'orange' }
      case _appUserDashboardTypes.nonProfiled:
        return { icon: 'user times', iconColor: 'grey' }
      case _appUserDashboardTypes.photo:
        return { icon: 'image', iconColor: 'green' }
      case _appUserDashboardTypes.nonPhoto:
        return { icon: 'image', iconColor: 'red' }
      case _appUserDashboardTypes.photoSourced:
        return { icon: 'image', iconColor: 'green' }
      case _appUserDashboardTypes.checkAuthorizations:
        return { icon: _.isEmpty(appUserAuthList) ? 'arrow right' : 'check circle', iconColor: _.isEmpty(appUserAuthList) ? 'blue' : 'green' }
      case _appUserDashboardTypes.getClientProfiles:
        return { icon: 'arrow right', iconColor: 'blue' }
      case _appUserDashboardTypes.authOn:
        return { icon: authOn ? 'check circle' : 'circle outline', iconColor: authOn ? 'green' : 'grey' }
      case _appUserDashboardTypes.getFiles:
        return { icon: 'file', iconColor: 'grey', isDrop: true, callback: handle_onFileDrop }
      default:
        return { icon: 'settings', iconColor: 'grey' }
    }
  }

  const ims_appUsers = () => {
    let _dts = _.clone(_normalDashboardTypes)
    if (!isSuperAdminDeveloper) {
      delete _dts.admins
    }
    const mis = _.mapValues(_.keyBy(_dts), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'App Users'} menuItems={mis} onClick={hc_appUsers} icon={'users'} />
  }

  const ims_appAuths = () => {
    const mis = _.mapValues(_.keyBy(_authDashboardTypes), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
      disabled: _.isEmpty(appUserAuthList)
    }));
    return <ItemMenuSquares caption={'App Auths'} menuItems={mis} onClick={hc_appUsers} icon={'user secret'} />
  }

  const ims_calAuths = () => {
    const mis = _.mapValues(_.keyBy(_calDashboardTypes), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
      disabled: _.isEmpty(appUserAuthList)
    }));
    return <ItemMenuSquares caption={'App Usage'} menuItems={mis} onClick={hc_appUsers} icon={'calendar'} />
  }

  const ims_appMissing = () => {
    const mis = _.mapValues(_.keyBy(_missingDashboardTypes), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'App Missing'} menuItems={mis} onClick={hc_appUsers} icon={'question'} />
  }

  const ims_appImage = () => {
    const mis = _.mapValues(_.keyBy(_imageDashboardTypes), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'App Images'} menuItems={mis} onClick={hc_appUsers} onDrop={handle_onFileDrop} icon={'image'} />
  }

  const ims_appFiles = () => {
    const mis = _.mapValues(_.keyBy(_imageFileTypes), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'App Files'} menuItems={mis} onClick={hc_appUsers} onDrop={handle_onFileDrop} icon={'image'} />
  }

  const ims_appOptions = () => {
    const mis = _.mapValues(_.keyBy(_optionDashboardTypes), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'Options'} menuItems={mis} onClick={hc_options} icon={'options'} />
  }

  return <React.Fragment>
    {ims_appUsers()}
    {!_.isEmpty(appUserAuthList) && ims_appAuths()}
    {!_.isEmpty(appUserAuthList) && ims_calAuths()}
    {ims_appMissing()}
    {ims_appImage()}
    {ims_appFiles()}
    {ims_appOptions()}
  </React.Fragment>

}
